import type { Optional } from '@festina-life/core'
import { createContext, useContext } from 'react'

import type { EventSelectionWithApplyDate } from '../commitmentEvents/commitmentEventSelectionContext'

type LegalEntityEventSelectionContext = {
  current: Optional<EventSelectionWithApplyDate>
  previous: Optional<EventSelectionWithApplyDate>
  setCurrent: (event: Optional<EventSelectionWithApplyDate>) => void
  setPrevious: (event: Optional<EventSelectionWithApplyDate>) => void
}

const LegalEntityEventSelectionContext =
  createContext<LegalEntityEventSelectionContext | null>(null)

const useLegalEntityEventSelectionContext = () => {
  const context = useContext(LegalEntityEventSelectionContext)

  if (!context) {
    throw new Error(
      'You must wrap your app in a LegalEntityEventSelectionProvider to use the LegalEntityEventSelectionContext',
    )
  }

  return context
}

const Provider = LegalEntityEventSelectionContext.Provider

export { Provider, useLegalEntityEventSelectionContext }
